(function($) {
  $('#site-navigation').accessibleMegaMenu({
    uuidPrefix: 'amenu',
    menuClass: 'amenu__main',
    topNavItemClass: 'amenu__top',
    panelClass: 'amenu__panel',
    panelGroupClass: 'sub-menu',
    hoverClass: 'hover',
    focusClass: 'focus',
    openClass: 'open',
  })
})(jQuery);
